import { AppAutocomplete } from "../form";
import type { WorkspaceSettings } from "../../services/workspaceService";

type LlmProvider = WorkspaceSettings["llmProvider"];

type ProviderOption = { value: LlmProvider; label: string };

const PROVIDER_OPTIONS: ProviderOption[] = [
  { value: "OPENAI", label: "OpenAI" },
  { value: "OLLAMA", label: "Ollama" },
  { value: "OPENAI_COMPATIBLE", label: "OpenAI-compatible (vLLM etc.)" },
];

type Props = {
  label?: string;
  value: LlmProvider;
  onChange: (value: LlmProvider) => void;
  disabled?: boolean;
};

export default function LlmProviderAutocomplete({ label = "Provider", value, onChange, disabled }: Props) {
  return (
    <AppAutocomplete<ProviderOption>
      label={label}
      options={PROVIDER_OPTIONS}
      value={PROVIDER_OPTIONS.find((o) => o.value === value) ?? PROVIDER_OPTIONS[0]}
      disableClearable
      autoHighlight
      openOnFocus
      disabled={disabled}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(a, b) => a.value === b.value}
      onChange={(_, option) => {
        if (option) onChange(option.value);
      }}
    />
  );
}
